<template>
  <div>
    <span :class="[color, color !='' ? 'white--text': '']"
      v-html="active ? textoHTML : textoHTML.slice(0,300)"> 
    </span>
    <span v-if="textoHTML.length > 299">
      {{ active ? '' : '...'}}
      <v-btn x-small text @click="active = !active">
        <span class="boton-mas">
          {{ active ? 'Leer menos' : 'Leer más'}}
        </span>
      </v-btn>
    </span>
</div>
</template>
<script>
import mixinGridComponenteCelda from "@/mixins/GridComponenteCelda.js"

export default {
  name: "CeldaTexto",
  mixins: [mixinGridComponenteCelda],
  data() {
    return {
       active: false,
    }
  },
  computed: {
    textoHTML() {
      return this.valor ? this.valor.replace('\n','<br>') : ''
    }
  },
};

</script>

<style lang="scss" scoped>
.boton-mas{
  color: blue;
}
</style>